import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const WebserverIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M14.38,12.08H5.62c-.8,0-1.46-.65-1.46-1.46v-2.5c0-.8.65-1.46,1.46-1.46h8.75c.8,0,1.46.65,1.46,1.46v2.5c0,.8-.65,1.46-1.46,1.46ZM5.62,7.92c-.12,0-.21.09-.21.21v2.5c0,.11.09.21.21.21h8.75c.12,0,.21-.09.21-.21v-2.5c0-.11-.09-.21-.21-.21H5.62Z" />
  <circle cx="12.71" cy="9.38" r=".62" />
  <path d="M14.38,16.25H5.62c-.8,0-1.46-.65-1.46-1.46v-2.5c0-.8.65-1.46,1.46-1.46h8.75c.8,0,1.46.65,1.46,1.46v2.5c0,.8-.65,1.46-1.46,1.46ZM5.62,12.08c-.12,0-.21.09-.21.21v2.5c0,.12.09.21.21.21h8.75c.12,0,.21-.09.21-.21v-2.5c0-.11-.09-.21-.21-.21H5.62Z" />
  <circle cx="12.71" cy="13.54" r=".62" />
  <path d="M17.71,19.17H2.29c-1.26,0-2.29-1.03-2.29-2.29V3.12C0,1.86,1.03.83,2.29.83h15.42c1.26,0,2.29,1.03,2.29,2.29v13.75c0,1.26-1.03,2.29-2.29,2.29ZM2.29,2.08c-.57,0-1.04.47-1.04,1.04v13.75c0,.57.47,1.04,1.04,1.04h15.42c.57,0,1.04-.47,1.04-1.04V3.12c0-.57-.47-1.04-1.04-1.04H2.29Z" />
  <path d="M19.38,5H.62c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h18.75c.34,0,.62.28.62.62s-.28.62-.62.62Z" />
 </svg>,
 "Webserver"
);
